export default "__VITE_ASSET__vqaX$f_c__"